import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
} from '@/components/forms/new/formStyles';

const CallingProfileDropdown = ({
    currentCompany,
    accountScope,
    setPlatformNumber,
    errors,
    darkMode,
    callingProfiles,
    submitData,
    platformID,
    isCurrentTrunkOC,
}) => {
    const platformIndex = submitData.findIndex(
        (platform) => platform.platformID === platformID,
    );
    const platform = submitData[platformIndex];

    const handleSelectChange = (item) => {
        setPlatformNumber((prev) => {
            const newPlatformNumbers = [...prev];
            newPlatformNumbers[platformIndex] = {
                ...platform,
                operatorConnectCallingProfileID: item.id,
            };
            return newPlatformNumbers;
        });
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors?.callingProfile}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Calling Profile
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                </Box>
                <Field
                    component={DropDown}
                    id="callingProfile"
                    name="callingProfile"
                    shownValue="name"
                    currentId={platform?.operatorConnectCallingProfileID}
                    handleSelectChange={handleSelectChange}
                    currentCompany={currentCompany}
                    accountScope={accountScope}
                    darkMode={darkMode}
                    data={callingProfiles}
                    validate={() => {
                        if (
                            isCurrentTrunkOC &&
                            !platform?.operatorConnectCallingProfileID
                        ) {
                            return 'Calling Profile is required for an Operator Connect number.';
                        }
                    }}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Calling Profiles control the Outbound calling route from Operator Connect. Please choose the correct profile for this numbers region/country. Please contact your Operator for further advice."
                        ariaLabel="numbers-calling-profile-dropdown-tooltip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default CallingProfileDropdown;
